export const iconFontAwesomeEditingPenClip = (
	<i className="fa-solid fa-pen-clip"></i>
);
